import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ConfirmationService, Message } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Fabricante } from 'src/app/admihair/api/dto/fabricante';
import { FabricanteService } from 'src/app/admihair/service/fabricante.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';


@Component({
  selector: 'app-fabricante-listar',
  templateUrl: './fabricante-listar.component.html',
  styleUrls: ['./fabricante-listar.component.scss']
})
export class FabricanteListarComponent implements OnInit {

  permissaoListar: boolean = false;
  permissaoInserir: boolean = false;
  permissaoEditar: boolean = false;
  permissaoDetalhar: boolean = false;
  permissaoExcluir: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  fabricantes: Fabricante[] = [];
  loadingFrabricantes: boolean = true;

  constructor(private fabricanteService: FabricanteService,
    private utilStorageService: UtilStorageService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private erroService: ErroService) { }
  
  @ViewChild('filter') filter!: ElementRef;

  ngOnInit(): void {3
    this.verificarPermissoes();
    if (this.permissaoListar) {
      this.listarFabricantes();
    }
  }

  listarFabricantes() {
    const empresaSelecionada: Empresa = this.utilStorageService.getEmpresa();
    this.fabricanteService.listarFabricantesPorEmpresaId(empresaSelecionada.id).subscribe({
      next: (data: Fabricante[]) => {
        this.loadingFrabricantes = false;
        this.fabricantes = data;
      },
      error: (err: any) => {
        this.loadingFrabricantes = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });

  }

  excluirFabricante(fabricanteId: number){
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.fabricanteService.excluir(fabricanteId).subscribe({
          next: () => {
            this.loadingFrabricantes = true;
            this.listarFabricantes();
            this.messages = this.erroService.handleSuccess();
            this.messagemVisivel = true;
            this.rolarTela();
          },
          error: (err: any) => {
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        });
      }
    });
  }

  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  editarFabricante(id: number){
    this._router.navigate(["/apps/fabricante/editar/" + id], { relativeTo: this._activatedRoute })
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_FABRICANTE');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_FABRICANTE');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_FABRICANTE');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_FABRICANTE');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_FABRICANTE');
  }
}
